import { render, staticRenderFns } from "./addMaterialFrames.vue?vue&type=template&id=7f304980&scoped=true&"
import script from "./addMaterialFrames.vue?vue&type=script&lang=js&"
export * from "./addMaterialFrames.vue?vue&type=script&lang=js&"
import style0 from "./addMaterialFrames.vue?vue&type=style&index=0&id=7f304980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f304980",
  null
  
)

export default component.exports